import { Link } from 'react-router-dom'
import { Home, Search, AlertCircle } from 'lucide-react'

function NotFound() {
  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <div className="w-20 h-20 sm:w-24 sm:h-24 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
          <AlertCircle className="w-10 h-10 sm:w-12 sm:h-12 text-gray-400" />
        </div>
        <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 dark:text-white mb-3 sm:mb-4">
          404
        </h1>
        <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-400 mb-6 sm:mb-8">
          页面不存在或已被移除
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <Link
            to="/"
            className="flex items-center justify-center gap-2 px-5 sm:px-6 py-2.5 sm:py-3 bg-dclaw-600 hover:bg-dclaw-700 text-white rounded-xl font-medium transition-colors text-sm sm:text-base min-h-[44px] w-full sm:w-auto"
          >
            <Home className="w-4 h-4 sm:w-5 sm:h-5" />
            返回首页
          </Link>
          <Link
            to="/skills"
            className="flex items-center justify-center gap-2 px-5 sm:px-6 py-2.5 sm:py-3 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-xl font-medium transition-colors text-sm sm:text-base min-h-[44px] w-full sm:w-auto"
          >
            <Search className="w-4 h-4 sm:w-5 sm:h-5" />
            浏览技能
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound
